import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.route_optimisation`. */
export const editRouteOptimisation = async (route_optimisation: object): Promise<any> =>
  writeSettingsFields({ route_optimisation });
